import RestClient from '../../../../../api/axiosInterceptor';
import { patientRegisterActions } from '../../../../actions/user/patient/auth/register';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REQUEST }); // Dispatch request action

    const response = await apiCall(); // Await the API response

    // Dispatch success action if the request is successful
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    return response; // Return the response to be handled in the UI
  } catch (error) {
    // Handle API or network errors
    dispatch({
      type: actionType.FAILURE,
      error: error.response ? error.response.data : error.message
    });
    throw error; // Propagate the error to the UI
  }
};

export const registerPatient = (formData) =>
  createAsyncAction(
    patientRegisterActions.REGISTER_PATIENT,
    () =>
      RestClient.post('/patient/register', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }) // The API endpoint to register a patient
  );
